import { AppBar, Dialog, Slide, Toolbar } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseMenuIcon } from 'assets/images/menu-close.svg';
import Branding from 'assets/images/trivia-branding.svg';
import styles from './styles.module.scss';

const Transition = React.forwardRef((props, ref) => (
  <Slide direction='down' ref={ref} {...props} />
));

const HamburgerMenu = ({ open, handleClose, userInfo, tabs, onLogout, onSettings }) => (
  <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
    <AppBar className={styles.appBar}>
      <Toolbar className={styles.toolBar}>
        <CloseMenuIcon className={styles.closeMenuIcon} onClick={handleClose} />
      </Toolbar>
    </AppBar>
    <div className={styles.hamburgerMenuWrapper}>
      <div className={styles.userInfo}>{userInfo}</div>
      <div className={styles.tabsLinks}>{tabs}</div>
      <div className={styles.logoutButton}>
        <div className={styles.logout} onClick={onLogout}>
          Logout
        </div>
        <div className={styles.help} onClick={onSettings}>
          Settings
        </div>
      </div>
      <div className={styles.brandingMobile}>
        <img src={Branding} alt='trivia' />
        <a href='https://trytrivia.co'>Having trouble? Get help</a>
      </div>
    </div>
  </Dialog>
);

HamburgerMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  userInfo: PropTypes.shape({
    name: PropTypes.string.isRequired
  }).isRequired,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired
    })
  ),
  onLogout: PropTypes.func.isRequired,
  onSettings: PropTypes.func.isRequired
};

HamburgerMenu.defaultProps = {
  tabs: []
};

export default HamburgerMenu;
